class ProductCardColor extends HTMLElement {
    connectedCallback() {
        this.container = this;
        this.scroll = this.querySelector(".card__colour-scroll");
        this.prevButton = this.querySelector(".card__colour-nav--prev");
        this.nextButton = this.querySelector(".card__colour-nav--next");
        this.items = this.querySelectorAll(".card__colour-grid-item");
        this.currentPosition = 0;
        this.gridGap = 6; // 4rem (item) + 0.6rem (gap)
        this.itemWidth = 46; // 4rem (item) + 0.6rem (gap)
        this.navButtonWidth = 32; // 2rem + padding

        if (!this.scroll || !this.prevButton || !this.nextButton) return;

        this.init();
    }

    init() {
        this.calculateWidths();

        // Hide arrows initially if not needed
        this.updateNavigation();
        this.bindEvents();
    }

    calculateWidths() {
        // Get the actual visible width (container width minus padding for arrows)
        this.containerWidth = this.container.offsetWidth;
        this.totalWidth = this.items.length * this.itemWidth;
        this.maxPosition = Math.max(0, this.totalWidth - this.containerWidth);
    }

    bindEvents() {
        this.prevButton.addEventListener("click", () => this.scrollPrev());
        this.nextButton.addEventListener("click", () => this.scrollNext());

        // Update on resize
        window.addEventListener("resize", () => {
            this.calculateWidths();
            this.currentPosition = Math.min(this.currentPosition, this.maxPosition);
            this.updatePosition();
        });
    }

    scrollNext() {
        // Calculate how many items are currently visible
        const visibleItems = Math.floor(this.containerWidth / this.itemWidth);
        // Move by the number of visible items
        const nextPosition = this.currentPosition + (visibleItems - 1) * this.itemWidth;
        this.currentPosition = Math.min(nextPosition, this.maxPosition);
        this.updatePosition();
    }

    scrollPrev() {
        // Calculate how many items are currently visible
        const visibleItems = Math.floor(this.containerWidth / this.itemWidth);
        // Move back by the number of visible items
        const prevPosition = this.currentPosition - (visibleItems - 1) * this.itemWidth;
        this.currentPosition = Math.max(prevPosition, 0);
        this.updatePosition();
    }

    updatePosition() {
        this.scroll.style.transform = `translateX(-${this.currentPosition}px)`;
        this.updateNavigation();
    }

    updateNavigation() {
        // Calculate how many items are fully visible
        const fullyVisibleItems = Math.floor((this.containerWidth + this.gridGap) / this.itemWidth);

        // Check if we need navigation (more items than can fit)
        const needsNavigation = this.items.length > fullyVisibleItems;
        if (!needsNavigation) {
            this.prevButton.classList.remove("card__colour-nav--showing");
            this.nextButton.classList.remove("card__colour-nav--showing");
            return;
        }

        // Show/hide prev button based on position
        this.prevButton.classList.toggle("card__colour-nav--showing", this.currentPosition > 0);

        // Calculate if there are more items to show
        const lastVisibleItemIndex = Math.ceil((this.currentPosition + this.containerWidth + this.gridGap) / this.itemWidth);
        const hasMoreItems = lastVisibleItemIndex <= this.items.length;

        this.nextButton.classList.toggle("card__colour-nav--showing", hasMoreItems);
    }
}
customElements.define("product-card-color", ProductCardColor);